module.exports = __webpack_public_path__ + "img/government-Industry-points2.ebf80e8f.png";